var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"poi-button",class:[
    _vm.bthDom&&_vm.bthDom,
    _vm.type ? 'poi-button--' + _vm.type : '',
    _vm.buttonSize ? 'poi-button--' + _vm.buttonSize : '',
    {
      'is-disabled': _vm.buttonDisabled,
      'is-loading': _vm.loading,
      'is-plain': _vm.plain,
      'is-round': _vm.round,
      'is-circle': _vm.circle,
      'poi-button--prefix': _vm.$slots.prefix,
      'poi-button--suffix': _vm.$slots.suffix
    }
  ],style:(_vm.fstyle),attrs:{"disabled":_vm.buttonDisabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.$slots.prefix)?_c('span',{staticClass:"poi-button__prefix"},[_vm._t("prefix")],2):_vm._e(),(_vm.$slots.suffix)?_c('span',{staticClass:"poi-button__suffix"},[_vm._t("suffix")],2):_vm._e(),(_vm.loading)?_c('i',{staticClass:"poi-icon-loading iconfont"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{staticClass:"iconfont",class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }